import { connect } from 'react-redux';
import { updateNft, deleteNft } from '../redux/actions';
var mapDispatchToProps = {
    updateNft: updateNft,
    deleteNft: deleteNft,
};
export default connect(null, mapDispatchToProps);
//# sourceMappingURL=NftLinkPopup.container.js.map